// The tab's remembered feed lives under this key. `recommendationFilters` writes and reads
// it (see `rememberFeedContext`); this module holds only the key and the forget, so
// `authManager` can clear it on logout without importing the filter machinery.
export const FEED_CONTEXT_KEY = 'recs_last_search';

/** Forget the remembered feed (logout): the next account in this tab must not land on it. */
export const forgetFeedContext = () => {
  try {
    sessionStorage.removeItem(FEED_CONTEXT_KEY);
  } catch {
    // Storage disabled: nothing was remembered.
  }
};
